import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { postAPIHandler, useBanners } from "../../Api/api";

// Ground Icons----------
import Capacity from "../../Images/Cricket-Pages/Grounds/capacity.png";
import Ends from "../../Images/Cricket-Pages/Grounds/Ends.png";
import Known_As from "../../Images/Cricket-Pages/Grounds/know as.png";
import Location from "../../Images/Cricket-Pages/Grounds/location.png";
import Opened from "../../Images/Cricket-Pages/Grounds/opened.png";
import Profile from "../../Images/Cricket-Pages/Grounds/profile.png";
import Timezone from "../../Images/Cricket-Pages/Grounds/timezone.png";
import Floodlights from "../../Images/Cricket-Pages/Grounds/floodlight.png";
import { Helmet } from "react-helmet";
import AdBanner from "../../Components/AdBanner";

const Venue_Details = () => {
  const { venueId } = useParams();
  const [venueDetails, setvenueDetails] = useState([]);
  // console.log("venueDetails - ", venueDetails);

    const { horizontal} = useBanners();


  const getvenueDetails = async (value) => {
    const formData = new FormData();
    formData.append("venue_id", value);

    const response = await postAPIHandler("venuesDetail", formData);
    setvenueDetails(response.data);
  };

  useEffect(() => {
    getvenueDetails(venueId);
  }, [venueId]);

  return (
    <>
      <Helmet>
        <title>
          Venue Details & Insights | Explore Sports Venues at cricket betting
          tips
        </title>
        <meta
          name="description"
          content="Find each of the information about the venue at cricket betting tips. Get in-depth information, history, and key features of top sports venues around the world."
        />
      </Helmet>
      {venueDetails.length !== 0 && (
        <div className="xl:w-[90%] w-[96%] mx-auto px-2 md:mt-10 py-7">
{/* ==========Advertisement============== */}
          <div className="lg:mb-5 mb-[10px]"><AdBanner data={horizontal} type="horizontal" /></div>

          <div className="bg-[linear-gradient(90.3deg,#F8DF65_0.16%,#AF6B16_50.89%,#F8DF65_101.62%)] rounded-lg py-3 mb-5 sm:w-[90%] mx-auto">
            <p className="text-white md:text-[30px] text-[24px] font-semibold px-4 flex items-center justify-center gap-x-4 mb-0">
              <img
                src={venueDetails.image}
                alt="squads"
                className="w-[50px] h-[50px] border-1 rounded-full border-[#fff] p-1"
              />
              {venueDetails.name}
            </p>
          </div>
          <div className="w-100 mb-10">
            <div className="bg-[#000000] border-2 rounded-[18px] border-[#252927]">
              <div
                className=" bg-[linear-gradient(90.3deg,#AF6B16_0.16%,#F8DF65_50.89%,#DC9A2B_101.62%)] w-[100%] py-3 rounded-t-[12px] md:px-7 px-3 flex items-center text-white font-medium 
 text-[20px]"
              >
                <p className="mb-0">Ground Picture</p>
              </div>
              <div className="">
                <img
                  alt="ground"
                  className="lg:h-[400px] xl:object-contain object-cover"
                  src={venueDetails.image}
                  style={{ borderRadius: "0px 0px 16px 16px" }}
                />
              </div>
            </div>
          </div>

{/* ==========Advertisement============== */}
          <div className="lg:mb-5 mb-[10px]"><AdBanner data={horizontal} type="horizontal" /></div>

          <div className="w-100">
            <div className="bg-[#000000] border-2 rounded-[18px] border-[#252927]">
              <div
                className=" bg-[linear-gradient(90.3deg,#AF6B16_0.16%,#F8DF65_50.89%,#DC9A2B_101.62%)] w-[100%] py-3 rounded-t-[12px] md:px-7 px-3 flex items-center text-white font-medium 
 text-[20px]"
              >
                <p className="mb-0">Ground Details</p>
              </div>
              <div className="py-4">
                <div className="flex px-4 flex-wrap gap-4 justify-between">
                  <div className="flex flex-col justify-start items-center lg:w-[18%] md:w-[30%] w-[45%]">
                    <img
                      className="w-[56px] h-[56px]" style={{ filter: "brightness(1000%)" }}
                      src={Capacity}
                      alt="capacity"
                    />
                    <p className="text-[16px] font-bold text-white mt-2 mb-1 text-center">
                      {venueDetails.capacity}
                    </p>
                    <p className="text-[#ffffffb0] text-sm">(Capacity)</p>
                  </div>
                  <div className="flex flex-col justify-start items-center lg:w-[18%] md:w-[30%] w-[45%]">
                    <img
                      className="w-[56px] h-[56px]" style={{ filter: "brightness(1000%)" }}
                      src={Profile}
                      alt="curator"
                    />
                    <p className="text-[16px] font-bold text-white mt-2 mb-1 text-center">
                      {venueDetails.curator}
                    </p>
                    <p className="text-[#ffffffb0] text-sm">(Curator)</p>
                  </div>
                  <div className="flex flex-col justify-start items-center lg:w-[18%] md:w-[30%] w-[45%]">
                    <img className="w-[56px] h-[56px]" style={{ filter: "brightness(1000%)" }} src={Ends} alt="ends" />
                    <p className="text-[16px] font-bold text-white mt-2 mb-1 text-center">
                      {venueDetails.ends}
                    </p>
                    <p className="text-[#ffffffb0] text-sm">(Ends)</p>
                  </div>
                  <div className="flex flex-col justify-start items-center lg:w-[18%] md:w-[30%] w-[45%]">
                    <img
                      className="w-[56px] h-[56px]" style={{ filter: "brightness(1000%)" }}
                      src={Floodlights}
                      alt="floodlights"
                    />
                    <p className="text-[16px] font-bold text-white mt-2 mb-1 text-center">
                      {venueDetails.floodlights}
                    </p>
                    <p className="text-[#ffffffb0] text-sm">(Floodlights)</p>
                  </div>
                  <div className="flex flex-col justify-start items-center lg:w-[18%] md:w-[30%] w-[45%]">
                    <img
                      className="w-[56px] h-[56px]" style={{ filter: "brightness(1000%)" }}
                      src={Capacity}
                      alt="home"
                    />
                    <p className="text-[16px] font-bold text-white mt-2 mb-1 text-center">
                      {venueDetails.home_to}
                    </p>
                    <p className="text-[#ffffffb0] text-sm">(Home)</p>
                  </div>
                  <div className="flex flex-col justify-start items-center lg:w-[18%] md:w-[30%] w-[45%]">
                    <img
                      className="w-[56px] h-[56px]" style={{ filter: "brightness(1000%)" }}
                      src={Known_As}
                      alt="known_as"
                    />
                    <p className="text-[16px] font-bold text-white mt-2 mb-1 text-center">
                      {venueDetails.known_as}
                    </p>
                    <p className="text-[#ffffffb0] text-sm">(Known As)</p>
                  </div>
                  <div className="flex flex-col justify-start items-center lg:w-[18%] md:w-[30%] w-[45%]">
                    <img
                      className="w-[56px] h-[56px]" style={{ filter: "brightness(1000%)" }}
                      src={Location}
                      alt="location"
                    />
                    <p className="text-[16px] font-bold text-white mt-2 mb-1 text-center">
                      {venueDetails.location}
                    </p>
                    <p className="text-[#ffffffb0] text-sm">(Location)</p>
                  </div>
                  <div className="flex flex-col justify-start items-center lg:w-[18%] md:w-[30%] w-[45%]">
                    <img
                      className="w-[56px] h-[56px]" style={{ filter: "brightness(1000%)" }}
                      src={Capacity}
                      alt="name"
                    />
                    <p className="text-[16px] font-bold text-white mt-2 mb-1 text-center">
                      {venueDetails.name}
                    </p>
                    <p className="text-[#ffffffb0] text-sm">(Ground Name)</p>
                  </div>
                  <div className="flex flex-col justify-start items-center lg:w-[18%] md:w-[30%] w-[45%]">
                    <img
                      className="w-[56px] h-[56px]" style={{ filter: "brightness(1000%)" }}
                      src={Opened}
                      alt="opened"
                    />
                    <p className="text-[16px] font-bold text-white mt-2 mb-1 text-center">
                      {venueDetails.opened}
                    </p>
                    <p className="text-[#ffffffb0] text-sm">(Opened)</p>
                  </div>
                  <div className="flex flex-col justify-start items-center lg:w-[18%] md:w-[30%] w-[45%]">
                    <img
                      className="w-[56px] h-[56px]" style={{ filter: "brightness(1000%)" }}
                      src={Timezone}
                      alt="timezone"
                    />
                    <p className="text-[16px] font-bold text-white mt-2 mb-1 text-center">
                      {venueDetails.time_zone}
                    </p>
                    <p className="text-[#ffffffb0] text-sm">(Time Zone)</p>
                  </div>
                  {venueDetails.profile.length > 0 && (
                    <div className="flex flex-col justify-start items-center w-100">
                      <img
                        className="w-[56px] h-[56px]" style={{ filter: "brightness(1000%)" }}
                        src={Capacity}
                        alt="about"
                      />
                      <p className="text-[16px] font-bold text-white mt-2 mb-1 text-center">
                        <span className="border-b-2 border-[#252927] pb-1">
                          {" "}
                          About
                        </span>
                      </p>
                      <div
                        className="text-gray text-md "
                        dangerouslySetInnerHTML={{
                          __html: venueDetails.profile,
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Venue_Details;
